import { CSSObject } from '@emotion/react'

/* Styling for account image, username, name, time(?), and caret icon */
const getAccountHeaderWrapper = (isMobile: boolean): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  margin: isMobile ? '13px 15px 0 16px' : '11px 18px 0 16px',
})

/* Styling for content */
const getContentWrapper = (isMobile: boolean): CSSObject => ({
  // Block, not the editor's default inline-block: a shrink-to-fit caption
  // grows to fit its longest unbreakable run of characters, so a bare URL
  // makes the caption wider than the post card and the copy spills over it.
  display: 'block',
  width: 'auto',
  margin: isMobile ? '18px 11px 8px 11px' : '10px 11px 15px 11px',
  fontSize: '22px',
  lineHeight: '29px',
})

/* Styling for account name */
const getAccountName = (isMobile: boolean): CSSObject => ({
  paddingTop: isMobile ? '6px' : '4px',
  fontWeight: 'bold',
  margin: '4px 0 0 8px',
  maxWidth: isMobile ? '265px' : 'unset',
  overflow: isMobile ? 'hidden' : 'inherit',
  textOverflow: isMobile ? 'ellipsis' : 'inherit',
})

const styles = {
  getAccountHeaderWrapper,
  getContentWrapper,
  getAccountName,
}

export { styles }
